var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('advanced-table',{attrs:{"headers":_vm.headers,"filters":_vm.filters,"sortBy":['created'],"sortDesc":[false],"resource":_vm.resource,"optionLists":_vm.optionLists}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }